import React, { Component, Fragment } from "react";
import CheckAuth from "../../../utils/hoc/CheckAuth";
import Steps from "../../../components/molecules/Steps";

import ProfilAction from "../../../redux/actions/Profil";
import DataPic from "../../../containers/organism/lengkapiProfil/DataPic";
import DataPerusahaan from "../../../containers/organism/lengkapiProfil/DataPerusahaan";
import DokumenPerusahaan from "../../../containers/organism/lengkapiProfil/DokumenPerusahaan";
import DataRekening from "../../../containers/organism/lengkapiProfil/DataRekening";
import DataKeuangan from "../../../containers/organism/lengkapiProfil/DataKeuangan";
import { connect } from "react-redux";
import { get_user_parameters } from "../../../config/api";
import GetParameter from "../../../utils/actions/GetParameter";
import { SET_ERROR_STATE } from "../../../utils/constants/actionTypes";
import {
  LP_PIC,
  LP_Company,
  LP_BankInfo,
  LP_Submit,
  LP_Borrower,
} from "../../../redux/actions/LengkapiProfile";
import RefreshToken from "../../../redux/actions/RefreshToken";
import Loading from "../../../components/molecules/Loading";
import TokenCIF from "../../../redux/actions/TokenCIF";
import {
  post_docs_perusahaan,
  get_bankcodes_params,
} from "../../../config/api";
import UploadWithText from "../../../utils/actions/UploadWithText";
import findNullInObj from "../../../utils/helpers/findNullInObj";

class LengkapiProfil extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      steps: {
        list: [
          "Data PIC",
          "Data Perusahaan",
          "Dokumen Perusahaan",
          "Data Rekening",
          "Laporan Keuangan",
        ],
        active: 0,
      },
      isComplete: [
        { status: false, key: "Data PIC", step: 0 },
        { status: false, key: "Data Perusahaan", step: 1 },
        { status: false, key: "Dokumen Perusahaan", step: 2 },
        { status: false, key: "Data Rekening", step: 3 },
        { status: false, key: "Laporan Keuangan", step: 4 },
      ],
      companyDocs: {
        AP0: false,
        //AP1: false,
        MK0: false,
        MK1: false,
        NPW: false,
        TDP: false,
        SIU: false,
      },
      financeDocs: { LR0: false, LKU: false },
      params: null,
      tokenCIF: null,
      paramsBankCode: null,
      loadingPage: false,
    };
  }

  setActiveSteps = (index) => {
    this.setState({
      ...this.state,
      steps: {
        ...this.state.steps,
        active: index,
      },
    });
  };

  setStateCompanyDocs = (key, status) => {
    let { companyDocs } = this.state;
    companyDocs[key] = status;

    this.setState({ companyDocs }, () => {
      //console.log("current docs === ", this.state.companyDocs);
    });
  };

  setStateFinanceDocs = (key, status) => {
    let { financeDocs } = this.state;
    financeDocs[key] = status;

    this.setState({ financeDocs }, () => {
      console.log("current docs === ", this.state.financeDocs);
    });
  };

  setStateLoadingPage = (status) => {
    if (this._isMounted) {
      this.setState({ loadingPage: status });
    }
  };

  getDisplay = (active) => {
    // console.log("apenih == ", this.state.params);

    switch (active) {
      case 0:
        return (
          <DataPic
            {...this.props}
            parameters={this.state.params}
            setLoadingPage={this.setStateLoadingPage}
            submit={this.sumbitProfPIC}
            setNewTokenCIF={(tokenCIF) => this.setState({ tokenCIF })}
          />
        );
      case 1:
        return (
          <DataPerusahaan
            {...this.props}
            parameters={this.state.params}
            submit={this.sumbitProfCompany}
          />
        );
      case 2:
        return (
          <DokumenPerusahaan
            {...this.props}
            submit={this.setActiveSteps}
            UploadCompanyDocs={this.UploadCompanyDocs}
            setStateCompanyDocs={this.setStateCompanyDocs}
          />
        );
      case 3:
        return (
          <DataRekening
            {...this.props}
            parameters={this.state.paramsBankCode}
            submit={this.submitBankInfo}
          />
        );
      case 4:
        return (
          <DataKeuangan
            {...this.props}
            UploadCompanyDocs={this.UploadCompanyDocs}
            submit={this.setActiveSteps}
            submitLP={this.submitLP}
            setStateFinanceDocs={this.setStateFinanceDocs}
          />
        );
      default:
        return null;
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  componentDidMount = () => {
    this._isMounted = true;
    const { GetProfile, ClientID, SetError } = this.props;

    const { setTitlePage } = this.props;
    setTitlePage({
      title: "Lengkapi Profil",
      breadcrumb: [
        { name: "Beranda", url: "/dashboard", status: false },
        { name: "Lengkapi Profil", url: "/#", status: true },
      ],
    });
    if (this._isMounted) {
      this.props.GetTokenCIF({ ClientID }, (tokenCIF) => {
        // console.log("fix berhasil === ", tokenCIF);
        this.setState({ tokenCIF });
      });
      //console.log("masuk lengkapi prof");
      GetParameter(get_user_parameters, null, (params, errMsg) => {
        if (errMsg) {
          SetError(errMsg);
        } else {
          // console.log("param berhasil === ", params.parameters);
          this.setState({ params: params.parameters }, () => {
            GetProfile(ClientID, null);
            GetParameter(
              get_bankcodes_params,
              null,
              (paramsBankCode, errMsg) => {
                if (errMsg) {
                  SetError(errMsg);
                } else {
                  // console.log("dumdidum === ", paramsBankCode);
                  this.setState({ paramsBankCode: paramsBankCode.banks });
                }
              }
            );
          });
        }
      });
    }
  };

  sumbitProfPIC = (data, refreshData) => {
    //console.log("submit === ", { data });
    // this.setActiveSteps(1)

    this.setStateLoadingPage(true);
    this.props.RefreshToken((ClientID) => {
      if (ClientID) {
        this.props.LP_PIC({ ClientID, data }, (status) => {
          this.setStateLoadingPage(false);
          if (status) {
            this.setActiveSteps(1);
            // refreshData()
          }
        });
      } else {
        this.setStateLoadingPage(false);
      }
    });
  };

  sumbitProfCompany = (data, dataKontakCompany, isBack) => {
    let { tokenCIF } = this.state;
    this.setStateLoadingPage(true);
    this.props.RefreshToken((ClientID) => {
      if (ClientID) {
        this.props.LP_Borrower(
          { ClientID, data: dataKontakCompany },
          (status) => {
            if (status) {
              this.props.GetTokenCIF({ ClientID, tokenCIF }, (newToken) => {
                // console.log("fix berhasil === ", tokenCIF);
                if (newToken) {
                  this.props.LP_Company(
                    { ClientID, tokenCIF: newToken, data },
                    (status) => {
                      this.setStateLoadingPage(false);
                      if (status) {
                        if (isBack) {
                          this.setActiveSteps(0);
                        } else {
                          this.setActiveSteps(2);
                        }
                      }
                    }
                  );
                }
                this.setState({ tokenCIF: newToken });
              });
            }
          }
        );
      }
    });
  };

  submitBankInfo = (data, isBack) => {
    //console.log("submit === ", { data });
    // this.setActiveSteps(1)
    this.setStateLoadingPage(true);
    this.props.RefreshToken((ClientID) => {
      if (ClientID) {
        this.props.LP_BankInfo({ ClientID, data }, (status) => {
          this.setStateLoadingPage(false);
          if (status) {
            if (isBack) {
              this.setActiveSteps(2);
            } else {
              this.setActiveSteps(4);
            }
          }
        });
      }
    });
  };

  UploadCompanyDocs = (id, data, idState, action) => {
    const { GetProfile, RefreshToken, SetError, GetTokenCIF } = this.props;
    let { tokenCIF } = this.state;

    RefreshToken((ClientID) => {
      if (ClientID) {
        GetTokenCIF({ ClientID, tokenCIF }, (newToken) => {
          if (newToken) {
            //console.log("nih mau upload");
            UploadWithText(
              post_docs_perusahaan(id),
              data,
              newToken,
              (hasil, error) => {
                //console.log("masuk sini kan harusnya  === ", { error, hasil });
                // GetProfile(ClientID, null)
                if (error) {
                  action(idState);
                  SetError(error);
                } else {
                  GetProfile(ClientID, () => {
                    action(idState);
                  });
                }
              }
            );
          } else {
            action(idState);
          }
          this.setState({ tokenCIF: newToken });
        });
      }
    });
  };

  checkIsComplete = () => {
    let { isComplete, companyDocs, financeDocs } = this.state;
    const { list } = this.props.profileState;
    const { picDetail, customerInfo, bankAccountInfo } = list;
    const { corporate } = customerInfo;

    isComplete[0].status = !findNullInObj(picDetail);
    // console.log({picDetail},findNullInObj(picDetail), isComplete);

    let domicile = !findNullInObj(corporate.domicileInfo);
    let dataCompany = !findNullInObj(corporate);
    let dataKontakCompany = list.companyPhone && list.companyEmail;
    if (domicile && dataCompany && dataKontakCompany) {
      isComplete[1].status = true;
    }
    // console.log({domicile, dataCompany, dataKontakCompany}, corporate.domicileInfo, corporate, [list.companyEmail, list.companyPhone]);

    let findNullDocs = Object.keys(companyDocs).find(
      (key) => !companyDocs[key]
    );
    isComplete[2].status = !findNullDocs;
    // console.log({companyDocs},findNullDocs, isComplete);

    isComplete[3].status = !findNullInObj(bankAccountInfo);
    console.log(
      { bankAccountInfo },
      findNullInObj(bankAccountInfo),
      isComplete
    );

    // bankAccountInfo

    // console.log({findIncomplete});

    let findNullDocsFinance = Object.keys(financeDocs).find(
      (key) => !financeDocs[key]
    );
    isComplete[4].status = !findNullDocsFinance;
    console.log({ financeDocs }, findNullDocsFinance, isComplete);

    console.log(isComplete);

    const findIncomplete = isComplete.find((element) => {
      return !element.status;
    });

    if (!findIncomplete) {
      return true;
    } else {
      const filterNotComplete = isComplete.filter((y) => y.status === false);

      this.props.SetError(
        `${filterNotComplete.map(
          (x) => " " + x.key
        )} yang anda masukkan belum lengkap. Mohon lengkapi terlebih dahulu.`
      );
      this.setActiveSteps(filterNotComplete[0].step);
      return false;
    }
  };
  submitLP = (data) => {
    let { tokenCIF } = this.state;
    //console.log("check data complete = ", this.checkIsComplete());

    this.setStateLoadingPage(true);
    if (this.checkIsComplete()) {
      this.props.RefreshToken((ClientID) => {
        if (ClientID) {
          this.props.GetTokenCIF({ ClientID, tokenCIF }, (newToken) => {
            // console.log("fix berhasil === ", tokenCIF);
            if (newToken) {
              this.props.LP_Submit(
                { ClientID, tokenCIF: newToken, data },
                (status) => {
                  this.setStateLoadingPage(false);
                  if (status) {
                    //console.log("berhasil horreeee");
                    this.props.history.push(`/`);
                  }
                }
              );
            }
            this.setState({ tokenCIF: newToken });
          });
        }
      });
    } else {
      this.setStateLoadingPage(false);
    }
  };
  render() {
    const { steps, params, loadingPage } = this.state;
    const { profileState, lengkapiProfil } = this.props;

    return (
      <Fragment>
        <Steps onClick={() => {}} list={steps.list} active={steps.active} />
        <div className="form-wrapper">
          {profileState.list && params && this.getDisplay(steps.active)}
        </div>
        <Loading
          display={
            loadingPage || lengkapiProfil.loading || profileState.isLoading
          }
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    col: {
      label: "col-12 col-lg-2 col-md-3",
      text: "col-12 col-lg-10 col-md-9 mt-2 mt-md-0",
    },
    profileState: state.profileState,
    lengkapiProfil: state.lengkapiProfil,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    GetProfile: (ClientID, cb) => {
      dispatch(ProfilAction(ClientID, cb));
    },
    SetError: (err) => {
      dispatch({ type: SET_ERROR_STATE, payload: err });
    },
    LP_PIC: ({ ClientID, data }, cb) => {
      dispatch(LP_PIC({ ClientID, data }, cb));
    },
    RefreshToken: (cb) => {
      dispatch(RefreshToken(cb));
    },
    GetTokenCIF: ({ ClientID, tokenCIF }, cb) => {
      dispatch(TokenCIF({ ClientID, tokenCIF }, cb));
    },
    LP_Company: ({ tokenCIF, ClientID, data }, cb) => {
      dispatch(LP_Company({ tokenCIF, ClientID, data }, cb));
    },
    LP_BankInfo: ({ ClientID, data }, cb) => {
      dispatch(LP_BankInfo({ ClientID, data }, cb));
    },
    LP_Submit: ({ tokenCIF, ClientID, data }, cb) => {
      dispatch(LP_Submit({ tokenCIF, ClientID, data }, cb));
    },
    LP_Borrower: ({ ClientID, data }, cb) => {
      dispatch(LP_Borrower({ ClientID, data }, cb));
    },
  };
};

export default CheckAuth(
  connect(mapStateToProps, mapDispatchToProps)(LengkapiProfil)
);
